import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ISettingsClickDomainsListResponse } from '@modules/general-settings/submodules/click-domains/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS,
  SETTINGS_CLICK_DOMAINS_LIST_QUERY_KEY,
  SETTINGS_CLICK_DOMAINS_LIST_URL,
} from '@modules/general-settings/submodules/click-domains/constants';

export default function useSettingsClickDomainsListQuery(): IContextQueryResult<ISettingsClickDomainsListResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsClickDomainsListResponse>({
    queryKey: [SETTINGS_CLICK_DOMAINS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_CLICK_DOMAINS_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_SHOW,
    }),
  });
}
